"use strict";
module.exports = ({
    "ropsten": {
        "PrivateNodeWallet": "0x62ba62ff92917edf8ac0386fa10e3b27950bce8d",
        "MANAToken": "0x2a8fd99c19271f4f04b1b7b9c4f7cf264b626edb",
        "LANDRegistry": "0x255baf4096cb1723c00c4b4390a4b3028ecaa8ba",
        "LANDProxy": "0x7a73483784ab79257bb11b96fd62a2c3ae4fb75b",
        "TerraformReserve": "0x4bc79175f1f6fded07f04aa1b4b0465ecff6f1b3",
        "ReturnVesting": "0x58c7e6e382c1c19c132b0361c12cbc33e2b13076",
        "LegacyMarketplace": "0x80faa2b517b84a5aec1078d3600eab4c0b3aff56",
        "Marketplace": "0x3d2f10c76b115db93a418ed286ca0c5abfdbf5d0",
        "MarketplaceProxy": "0x5424912699dabaa5f2998750c1c66e73d67ad219",
        "ServiceLocator": "0xb240b30c12d2a9ea6ba3abbf663d9ae265fbebeb",
        "MortgageHelper": "0x0e4c24f71c8679b8af8e5a22aac3816e2b23f1cc",
        "MortgageManager": "0x31ebb4ffd5e34acfc87ea21a0c56157188f3f0e1",
        "RCNEngine": "0xbeE217bfe06C6FAaa2d5f2e06eBB84C5fb70d9bF",
        "RCNToken": "0x2f45b6fb2f28a73f110400386da31044b2e953d4",
        "KyberOracle": "0x4931d0621360187199de494a1469165079b31bfc",
        "DecentralandInvite": "0x7557dfa02f3bd7d274851e3f627de2ed2ff390e8",
        "EstateRegistry": "0x60e315992d5e62457215dd1e6a49d1ceb7983dfc",
        "EstateProxy": "0x124bf28a423b2ca80b3846c3aa0eb944fe7ebb95",
        "ERC721Bid": "0x250fa138c0a994799c7a49df3097dc71e37b3d6f",
        "BidMANABurner": "0x01f43c3133b83086d4776027fbd152fa8a685fb4",
        "AvatarNameRegistry": "0xd127F8d9C736d91Acdee34645e0b4C9db7178160",
        "AvatarNameRegistryProxy": "0x2d794a7c956624fb93Eb3ff6E48D5b5d6dBA127b",
        "ExclusiveMasksCollection": "0x30ae57840b0e9b8ea55334083d53d80b2cfe80e0",
        "DCLRegistrar": "0xeb6f5d94d79f0750781cc962908b161b95192f53",
        "DCLController": "0xd4e92f6ea18412dbae8b2d2b69e498a2d1064fa2",
        "Catalyst": "0xadd085f2318e9678bbb18b3e0711328f902b374b",
        "BuyAdapter": "0xd1e4e2880ff56cd0d5c68da9bed58bfbf0150948",
        "AdapterFeeCollector": "0x5DC888024cB599CfDdb9E6483ED6bAe1fA9e9D18",
        "AdapterConverter": "0x2782eb28Dcb1eF4E7632273cd4e347e130Ce4646",
        "POIAllowlist": "0x5DC4a5C214f2161F0D5595a6dDd9352409aE3Ab4",
        "NAMEDenylist": "0x20c6f1e86eba703a14414a0cbc1b55c89dba7a0f",
        "CollectionsV2Factory": "0x16d8bac5b67a6b782a9081377bec413bc5bb56a6",
        "VestingImpl": "0xc243b243a2033348730420ea55239767802a19d0",
        "VestingFactory": "0xcbfa36f59246ae43cb827a77f6ca955b93dd6042",
        "BatchVesting": "0xedbea1174b892f88a836f61de395f5f155d4d2a9"
    },
    "mainnet": {
        "MANAToken": "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
        "LANDRegistry": "0x554bb6488ba955377359bed16b84ed0822679cdc",
        "LANDProxy": "0xf87e31492faf9a91b02ee0deaad50d51d56d5d4d",
        "TerraformReserve": "0xcca95e580bbbd04851ebfb85f77fd46c9b91f11c",
        "ReturnVesting": "0x79c1fdaba012b9a094c495a86ce5c6199cf86368",
        "LegacyMarketplace": "0xb3bca6f5052c7e24726b44da7403b56a8a1b98f8",
        "Marketplace": "0x19a8ed4860007a66805782ed7e0bed4e44fc6717",
        "MarketplaceProxy": "0x8e5660b4ab70168b5a6feea0e0315cb49c8cd539",
        "ServiceLocator": "0x151b11892dd6ab1f91055dcd01d23d03a2c47570",
        "MortgageHelper": "0x90263ea5c57dc6603ca7202920735a6e31235bb9",
        "MortgageManager": "0x9abf1295086afa0e49c60e95c437aa400c5333b8",
        "RCNEngine": "0xba5a17f8ad40dc2c955d95c0547f3e6318bd72e7",
        "RCNToken": "0xf970b8e36e23f7fc3fd752eea86f8be8d83375a6",
        "KyberOracle": "0x2aaf69a2df2828b55fa4a5e30ee8c3c7cd9e5d5b",
        "DecentralandInvite": "0xf886313f213c198458eba7ae9329525e64eb763a",
        "EstateRegistry": "0x1784ef41af86e97f8d28afe95b573a24aeda966e",
        "EstateProxy": "0x959e104e1a4db6317fa58f8295f586e1a978c297",
        "LANDAuction": "0x54b7a124b44054da3692dbc56b116a35c6a3e561",
        "MANABurner": "0xadfeb1de7876fcabeaf87df5a6c566b70f970018",
        "MultiSigWallet": "0x4eac6325e1dbf1ac90434d39766e164dca71139e",
        "Nobody": "0xDf861993Edbe95BAFbfA7760838f8ebbd5Afda9F",
        "ERC721Bid": "0xe479dfd9664c693b2e2992300930b00bfde08233",
        "BidMANABurner": "0x0fcf114c63a5387878e0da051c81cb6febd93b6c",
        "MultisigContractOwner": "0xefc549434a03756f6e37a43757a2927605d8839b",
        "AvatarNameRegistry": "0x894b883905bfEe2CC448880F1b59f4A762E67566",
        "AvatarNameRegistryProxy": "0xcd816354450015A5644857FEd507afEeaE7263af",
        "ExclusiveMasksCollection": "0xc04528c14c8ffd84c7c1fb6719b4a89853035cdd",
        "Halloween2019Collection": "0xc1f4b0eea2bd6690930e6c66efd3e197d620b9c2",
        "Halloween2019CollectionFactory": "0x07ccfd0fbada4ac3c22ecd38037ca5e5c0ad8cfa",
        "Xmas2019Collection": "0xc3af02c0fd486c8e9da5788b915d6fff3f049866",
        "DCLRegistrar": "0x2a187453064356c898cae034eaed119e1663acb8",
        "DCLController": "0x6843291bd86857d97f0d269e698939fb10d60772",
        "Catalyst": "0xcc054fab08127c19f621ab83ade5962cd10584ec",
        "CatalystProxy": "0x4a2f10076101650f40342885b99b6b101d83c486",
        "MCHCollection": "0xf64dc33a192e056bb5f0e5049356a0498b502d50",
        "CommunityContestCollection": "0x32b7495895264ac9d0b12d32afd435453458b1c6",
        "DCLLaunchCollection": "0xd35147be6401dcb20811f2104c33de8e97ed6818",
        "DCGCollection": "0x3163d2cfee3183f9874e2869942cc62649eeb004",
        "StaySafeCollection": "0x201c3af8c471e5842428b74d1e7c0249adda2a92",
        "StaySafeDonation": "0x56505a0313ba2b4bc0be23dbb7eb71b7885fca9e",
        "ClaimWearableForFree": "0x8dd61d1a67bce13a87e20a76c6f164c388a726d6",
        "Moonshot2020Collection": "0x6a99abebb48819d2abe92c5e4dc4f48dc09a3ee8",
        "DAOAgent": "0x9A6ebE7E2a7722F8200d0ffB63a1F6406A0d7dce",
        "DAOEstateForwarder": "0x34ed9e73930290cec0cfe601809255ec1313ea18",
        "LANDMiniMeToken": "0x20dfe381ca71ade2582094cf569a8cb020af5ab1",
        "EstateMiniMeToken": "0x8568f23f343694650370fe5e254b55bfb704a6c7",
        "BuyAdapter": "0xf4fbd84193f9aaf9779dedbb415a806933eb1c95",
        "AdapterFeeCollector": "0x0d58aaae9f0c4d020486f534363f3fca7a6aecb6",
        "AdapterConverter": "0x2859581da59bd4e16a866dd06b461b76d8e489a4",
        "DappcraftMoonminerCollection": "0x1e1d4e6262787c8a8783a37fee698bd42aa42bec",
        "DGSummer2020Collection": "0xbf53c33235cbfc22cef5a61a83484b86342679c5",
        "PMOuttathisworldCollection": "0x75a3752579dc2d63ca229eebbe3537fbabf85a12",
        "DgtbleHeadspaceCollection": "0x574f64ac2e7215cba9752b85fc73030f35166bc0",
        "WonderzoneMeteorchaserCollection": "0x34ed0aa248f60f54dd32fbc9883d6137a491f4f3",
        "BurningStore": "0x0822d44c2e2f96d4cccad80610134861802b2cca",
        "BaseList": "0x21b6EFf834d7cc8c12A5Ec924939aa521F0FE83F",
        "POIAllowListProxy": "0x0ef15a1c7a49429a36cb46d4da8c53119242b54e",
        "NameDenyListProxy": "0x0c4c90a4f29872a2e9ef4c4be3d419792bca9a36",
        "BinanceUsCollection": "0xa8ee490e4c4da48cc1653502c1a77479d4d818de",
        "PMDreamverseEminence": "0x09305998a531fade369ebe30adf868c96a34e813",
        "CybermikeCyberSoldier": "0x24d538a6265b006d4b53c45ba91af5ef60dca6cb",
        "DCMeta": "0xe7a64f6a239ed7f5bf18caa1ce2920d0c1278129",
        "WZWonderbot": "0x5df4602e7f38a91ea7724fc167f0c67f61604b1e",
        "DGFall2020": "0x7038e9d2c6f5f84469a84cf9bc5f4909bb6ac5e0",
        "MFSammichgamer": "0x30d3387ff3de2a21bef7032f82d00ff7739e403c",
        "SugarclubYumi": "0xb5d14052d1e2bce2a2d7459d0379256e632b855d",
        "EtheremonWearables": "0x54266bcf2ffa841af934f003d144957d5934f3ab",
        "MLPekingopera": "0x60d8271c501501c4b8cd9ed5343ac59d1b79d993",
        "ChinaFlying": "0x90958d4531258ca11d18396d4174a007edbc2b42",
        "TechTribalMarc0matic": "0x480a0f4e360e8964e68858dd231c2922f1df45ef",
        "DigitalAlchemy": "0x5cf39e64392c615fd8086838883958752a11b486",
        "CZMercenaryMTZ": "0xc3ca6c364b854fd0a653a43f8344f8c22ddfdd26",
        "WonderzoneSteampunk": "0xb96697fa4a3361ba35b774a42c58daccaad1b8e1",
        "DCNiftyblocksmith": "0x102daabd1e9d294d4436ec4c521dce7b1f15499e",
        "Halloween2020Collection": "0xfeb52cbf71b9adac957c6f948a6cf9980ac8c907",
        "Xmas2020Collection": "0xecf073f91101ce5628669c487aee8f5822a101b1",
        "MemeDontBuyThis": "0x1a57f6afc902d25792c53b8f19b7e17ef84222d5",
        "ReleaseTheKraken": "0xffc5043d9a00865d089d5eefa5b3d1625aec6763",
        "3LAUBasics": "0xe1ecb4e5130f493551c7d6df96ad19e5b431a0a9",
        "XmashUp2020": "0xdd9c7bc159dacb19c9f6b9d7e23948c87aa2397f",
        "MLLiondance": "0x0b1c6c75d511fae05e7dc696f4cf14129a9c43c9",
        "AtariLaunch": "0x4c290f486bae507719c562b6b524bdb71a2570c9",
        "ERC20Predicate": "0x40ec5B33f54e0E8A33A975908C5BA1c14e5BbbDf",
        "RootChainManagerProxy": "0xA0c68C638235ee32657e8f720a23ceC1bFc77C77",
        "RootChainProxy": "0x86E4Dc95c7FBdBf52e33D563BbDB00823894C287",
        "RTFKTXAtari": "0x6b47e7066c7db71aa04a1d5872496fe05c4c331f",
        "RACBasics": "0x68e139552c4077ce5c9ab929c7e18ca721ffff00",
        "WinklevossCapital": "0xc82a864a94db3550bc71fcb4ce07228bcec21f1a",
        "DGAtariDillonFrancis": "0x51e0b1afe5da0c038fc93a3fc8e11cf7a238b40b",
        "DAOVotingPower": "0xcf9b305b4cd210079f5648f17ede69e666c0c8d4",
        "TheGraphMultisig": "0x89FDdaB2F93417182CdCdb0B8B3322B93AB3A192",
        "VestingImpl": "0x42f32e19365d8045661a006408cc6d1064039fbf",
        "VestingFactory": "0xe357273545c152f07afe2c38257b7b653fd3f6d0",
        "BatchVesting": "0xc57185366bcda81cde363380e2099758712038d0"
    },
    "kovan": {
        "MANAToken": "0x230fc362413d9e862326c2c7084610a5a2fdf78a",
        "LANDRegistry": "0x2059291430b9aa2F79547f657816eFb816b36614",
        "LANDProxy": "0x537263c440943f6a6808bCb8CcB3fe03EE838aD1",
        "Marketplace": "0x6f44f195999f06aeb5872db96cdc517f1e839f13"
    },
    "rinkeby": {
        "MANAToken": "0x28bce5263f5d7f4eb7e8c6d5d78275ca455bac63",
        "LANDProxy": "0x28bef22df3e2040a4be64a9ca0e8b5ae2b91462d",
        "LANDRegistry": "0xbeea8bfb0e582be1c3fb464824e61c218ba0c1b1",
        "EstateRegistry": "0x3f0b58ad7a8b27d0e5573cd1ca7d456e2f6d4884",
        "Multisig": "0x0de35b8b47b129877e0efca24e294b61d7e7eee3",
        "MANAMiniMeToken": "0xfb2712a1246f712b889692c7ce55fec25c06bc33",
        "LANDMiniMeToken": "0x576c4577aAd561EA79acbd49215a0cC1473BfCCA",
        "EstateMiniMeToken": "0x2b98C125733035cDE09d311F988845808EE270E6",
        "DAOVotingPower": "0xe65835cd7c9311866ae5d260a1eb7b963899ca14",
        "VestingImpl": "0x8493bb6ae17e12c062b0eb1fe780cc0b2df16bb2",
        "VestingFactory": "0x64c9f713a743458ab22ec49d88dd00621f528786"
    },
    "goerli": {
        "MANAToken": "0xe7fDae84ACaba2A5Ba817B6E6D8A2d415DBFEdbe",
        "ERC20Predicate": "0xdD6596F2029e6233DEFfaCa316e6A95217d4Dc34",
        "RootChainManagerProxy": "0xbbd7cbfa79faee899eaf900f13c9065bf03b1a74",
        "RootChainProxy": "0x2890ba17efe978480615e330ecb65333b880928e",
        "LANDRegistry": "0x0cfF059845c6Abee7De396d00091016ad72FD324",
        "LANDProxy": "0x25b6B4bac4aDB582a0ABd475439dA6730777Fbf7",
        "EstateRegistry": "0x5309aE874FC4eB21adCd63f8b6C3f766Cc3B1849",
        "EstateProxy": "0xC9A46712E6913c24d15b46fF12221a79c4e251DC",
        "RentalsProxyAdmin": "0x6ad9fb3f07a6013e6db2327e27ad0a38e858d88d",
        "RentalsProxy": "0xbb2a03bf5f525734cb0536be4be61ba788d7ee01",
        "RentalsImplementation": "0xe70db6319e9cee3f604909bdade58d1f5c1cf702",
        "MarketplaceProxy": "0x5d01fbD3E22892be40F69bdAE7Ad921C8cdA2085",
        "MarketplaceImplementation": "0x09B389B3523870798f46555fef26B4476A973E6E",
        "MarketplaceLegacyNFT": "0x0fFc7E6D72eE2F287B877533454210621b1B7822",
        "DCLRegistrar": "0x6b8da2752827cf926215b43bb8E46Fd7b9dDac35",
        "DCLController": "0x6fF05B6271BBEd8F16a46e6073d27aD94224E0Ac",
        "ERC721Bid": "0xd7dC1C183B8fFaED6b7f30fFC616Ff81B66812e5",
        "ExclusiveMasksCollection": "0x1f0880E0b4514DC58e68B9BE91693bFA8C067ac1",
        "NAMEDenylist": "0x71c84760df0537f7db286274817462dc2e6c1366",
        "Catalyst": "0x380e46851c47b73b6aa9bea50cf3b50e2cf637cf",
        "POIAllowlist": "0xb8c7a7afd42675ab61f0a3732f8d0491825a933b"
    },
    "matic": {
        "MetaTxForwarder": "0x0baBda04f62C549A09EF3313Fe187f29c099FF3C",
        "MANAToken": "0xA1c57f48F0Deb89f569dFbE6E2B7f46D33606fD4",
        "ChildChainManagerProxy": "0xA6FA4fB5f76172d178d61B04b0ecd319C5d1C0aa",
        "SABMultisig": "0x0E659A116e161d8e502F9036bAbDA51334F2667E",
        "CommitteeMultisig": "0xB08E3e7cc815213304d884C88cA476ebC50EaAB2",
        "CollectionImplementation": "0x006080C6061C4aF79b39Da0842a3a22A7b3f185e",
        "Rarities": "0x17113b44fdd661A156cc01b5031E3aCF72c32EB3",
        "RaritiesWithOracle": "0xA9158E22F89Bb3F69c5600338895Cb5FB81e5090",
        "OldCommittee": "0x71d9350Ef44E1e451F00e447C0DfF2d1FB75510a",
        "Committee": "0xaeec95a8aa671a6d3fec56594827d7804964fa70",
        "CollectionManager ": "0x9D32AaC179153A991e832550d9F96441Ea27763A",
        "Forwarder": "0xBF6755A83C0dCDBB2933A96EA778E00b717d7004",
        "CollectionFactory": "0xB549B2442b2BD0a53795BC5cDcBFE0cAF7ACA9f8",
        "CollectionFactoryV3": "0x3195e88aE10704b359764CB38e429D24f1c2f781",
        "CollectionStore": "0x214ffC0f0103735728dc66b61A22e4F163e275ae",
        "Marketplace": "0x02080031b45A3c67d338Dd4A2CC309D28756A160",
        "TPRAdmin": "0xF44063d872C88eEBab2EFC0318194e75a5218C1E",
        "TPRProxy": "0x1C436C1EFb4608dFfDC8bace99d2B03c314f3348",
        "TPR": "0x1f8063CC04398Be214a7d8dD25B6b6e2b870d99e",
        "ChainlinkOracle": "0x1a91dd8d4eeddc2fac31f36818604b7093dc95e0",
        "RoyaltiesManager": "0x90958D4531258ca11D18396d4174a007edBc2b42",
        "MarketplaceV2": "0x480a0f4e360E8964e68858Dd231c2922f1df45Ef",
        "ERC721Bid": "0xb96697FA4A3361Ba35B774a42c58dACcaAd1B8E1",
        "FoundationEOACreator1": "0x6ADf75e49bAC21abab9AdB9266d2cC6d90AbD31a",
        "UpgradeableBeacon": "0xDDb3781Fff645325C8896AA1F067bAa381607ecc"
    },
    "mumbai": {
        "dAppsAdmin": "0xb919da06d5f81777B13Fc5CBd48635E19500Fbf5",
        "MetaTxForwarder": "0xBF6755A83C0dCDBB2933A96EA778E00b717d7004",
        "MANAToken": "0x882Da5967c435eA5cC6b09150d55E8304B838f45",
        "ChildChainManagerProxy": "0xb5505a6d998549090530911180f38aC5130101c6",
        "CollectionImplementation": "0x89c4Ad77066d9EE8aD281D5Fd995690D91436644",
        "Rarities": "0x8eabF06f6cf667915bfF30138be70543bCE2901A",
        "RaritiesWithOracle": "0xb9957735bbe6D42585058Af11AA72da8eAD9043a",
        "OldCommittee": "0x4bb5ACe5ceB3Dd51ea35fa01a8f9B5507c234270",
        "Committee": "0xe18B1361d41afC44658216F3Dc27e48c2336e3c2",
        "CollectionManager ": "0xe539E0AED3C1971560517D58277f8dd9aC296281",
        "Forwarder": "0x71e56Ad57eca3fAAe5077b7F9ea731a25785fF92",
        "CollectionFactory": "0x2A72Ec4241Ac4fBc915ae98aC5a5b01AdE721f4B",
        "CollectionFactoryV3": "0xDDb3781Fff645325C8896AA1F067bAa381607ecc",
        "CollectionStore": "0x6ddF1b1924DAD850AdBc1C02026535464Be06B0c",
        "Marketplace": "0x2a09a000224f5dbe0E17214cA95CDe506DA7CB74",
        "TPRAdmin": "0xa1Ee2a8bDAEF0AB178D1088Cb3Ae0537c8eB4B8e",
        "TPRProxy": "0xEDf516F2D42A47F9cE0B145Fe0dbB76975379889",
        "TPR": "0x3CFe76fbf8E2868075c10161667ab3Fea19cA8D2",
        "ChainlinkOracle": "0x05b0a8195aa4c21944d68f71a263f836670e3605",
        "DummyDataFeed": "0x5521ade5494225e0936c74f97e474107d73c406e",
        "ThirdPartyTiers": "0xdC899B9c1Fa80292606C3cfbA88bbBf0935c2e48",
        "RoyaltiesManager": "0x68838E6068a3a925a78546E475dE73C75e4F2651",
        "MarketplaceV2": "0x5A467398dfa9d5C663a656423A2D055f538198A4",
        "ERC721Bid": "0x78Dd92c8941dBC7BE54E2a9390D58aD28AD97afD",
        "UpgradeableBeacon": "0x0c8ad1f6aadf89d2eb19f01a100a6143108fe2b0"
    }
});
//# sourceMappingURL=contracts.js.map